import gql from 'graphql-tag'

export const getUsuarioLogadoRolesQueryGql = gql`
  query GetUsuarioLogadoRolesQuery {
    usuarioLogado {
      id
      tipo {
        id
      }
      funcionalidades {
        id
        chave
      }
    }
  }
`
